export const checkPharmacy = {
	CL: {
		handle: (props) => {
			return props.despatch_info.some((iterator) => iterator.title === 'Retiro');
		},
	},
		CLNARMA: {
		handle: (props) => {
			return props.despatch_info.some((iterator) => iterator.title === 'Retiro');
		},
	},

		CLGREEN: {
		handle: (props) => {
			return props.despatch_info.some((iterator) => iterator.title === 'Retiro');
		},
	},
	CLANICX: {
		handle: (props) => {
			return props.despatch_info.some((iterator) => iterator.title === 'Retiro');
		},
	},
	AR: {
		handle: (props) => {
			return props.despatch_info.some((iterator) => iterator.title === 'Retiro');
		},
	},
};
checkPharmacy.CLZUPHARMA = checkPharmacy.CLGREEN;
